var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4638 13.1476H14.3484M1.64844 13.1476L5.20281 12.4315C5.3915 12.3934 5.56476 12.3005 5.70083 12.1644L13.6576 4.20321C14.0391 3.82152 14.0389 3.2028 13.6571 2.82143L11.9715 1.1378C11.5899 0.756576 10.9715 0.756836 10.5901 1.13838L2.6325 9.10037C2.49669 9.23625 2.40397 9.40915 2.36591 9.59746L1.64844 13.1476Z",
    stroke: "#2D3036",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTag);
export default __webpack_public_path__ + "static/media/edit-tag.bd4c630389b431ffc24686335dda502e.svg";
export { ForwardRef as ReactComponent };